export default __webpack_public_path__ + "static/media/captain-arrow.d78dfbff.png";